import { useMutation } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";
import useAxiosInstance from "./utils/axiosIntance";

type ExitGamePayload = {};
type ExitGameResponse = {
  isSuccess: boolean;
};
const useExitGame = () => {
  const axios = useAxiosInstance();
  const { mutate: exitGame } = useMutation<
    AxiosResponse<ExitGameResponse>,
    AxiosError,
    ExitGamePayload
  >({
    mutationFn: () => {
      return axios.patch(
        `/game/exit`,
        {},
        {
          withCredentials: true,
        }
      );
    },
  });
  return exitGame;
};

export default useExitGame;
